import {errorN} from "../../general";

// WiFi guest accounts, same as Windows (frmCheckInOut / frmEditFolios / MyClass): only when
// System Settings > Device > WiFi is on. Talks to the local service on port 8023, like /card_issue.
// Nothing here throws: a failure shows "WIFI ERROR: ..." and the check-in/out or printout carries on.

const WIFI_BASE = 'http://localhost:8023';
const WIFI_TIMEOUT = 5000;

function wifiSetting(devicesetting) {
    let ds = devicesetting;

    if (ds === undefined)
    {
        try { ds = JSON.parse(localStorage.getItem('devicesetting')); } catch (e) { ds = null; }
    }

    let w = ds !== null && ds !== undefined && ds.data !== undefined && ds.data !== null ? ds.data.wifi : null;
    return w !== null && w !== undefined && w.wifi === true ? w : null;
}

async function wifiFetch(path, method) {
    let controller = new AbortController();
    let timer = setTimeout(() => controller.abort(), WIFI_TIMEOUT);

    try
    {
        let res = await fetch(`${WIFI_BASE}${path}`, {method: method, signal: controller.signal});
        let body = await res.text();

        if (!res.ok)
        {
            throw new Error(`${res.status} ${res.statusText}`);
        }

        return body;
    }
    catch (err)
    {
        if (err.name === 'AbortError')
        {
            throw new Error('WiFi service not responding');
        }

        // fetch() rejects with a TypeError when nothing answers on the port.
        throw new Error(err instanceof TypeError ? `WiFi service not reachable (${WIFI_BASE})` : (err.message || String(err)));
    }
    finally
    {
        clearTimeout(timer);
    }
}

async function wifiList(w) {
    let body = await wifiFetch(`/wifi_list?ip=${encodeURIComponent(w.routerIP || '')}`, 'GET');
    let ls = JSON.parse(body);
    return Array.isArray(ls) ? ls : [];
}

function isNotOk(body) {
    return String(body).trim().toUpperCase() === 'NOT OK';
}

// The unit no. for an allocation's room id, from the room list the dashboard keeps.
export function unitNoFromRoomId(roomid) {
    try
    {
        let roomList = JSON.parse(localStorage.getItem('roomlist')) || [];
        let r = roomList.find(x => x.id === roomid);
        return r !== undefined ? r.data.no : null;
    }
    catch (err)
    {
        return null;
    }
}

// After a successful check-in: create the unit's account if it is not there yet.
export async function wifiEnsure(unitNo, devicesetting) {
    let w = wifiSetting(devicesetting);
    if (w === null)
    {
        return;
    }

    try
    {
        if (unitNo === null || unitNo === undefined || unitNo === '')
        {
            throw new Error('Unit no. not found');
        }

        let ls = await wifiList(w);
        if (ls.some(x => x.name === unitNo))
        {
            return;
        }

        let body = await wifiFetch(`/wifi_create?room=${encodeURIComponent(unitNo)}&ip=${encodeURIComponent(w.routerIP || '')}`, 'POST');
        if (isNotOk(body))
        {
            throw new Error(`Create account for ${unitNo} failed`);
        }
    }
    catch (err)
    {
        errorN(`WIFI ERROR: ${err.message}`);
    }
}

// After a successful check-out: remove the unit's account if it is there.
export async function wifiRemove(unitNo, devicesetting) {
    let w = wifiSetting(devicesetting);
    if (w === null)
    {
        return;
    }

    try
    {
        if (unitNo === null || unitNo === undefined || unitNo === '')
        {
            throw new Error('Unit no. not found');
        }

        let ls = await wifiList(w);
        if (!ls.some(x => x.name === unitNo))
        {
            return;
        }

        let body = await wifiFetch(`/wifi_remove?room=${encodeURIComponent(unitNo)}&ip=${encodeURIComponent(w.routerIP || '')}`, 'POST');
        if (isNotOk(body))
        {
            throw new Error(`Remove account for ${unitNo} failed`);
        }
    }
    catch (err)
    {
        errorN(`WIFI ERROR: ${err.message}`);
    }
}

// For printouts: [{unit, password}] for the given units that have an account, [] otherwise.
export async function wifiLogins(unitNos, devicesetting) {
    let w = wifiSetting(devicesetting);
    if (w === null || !Array.isArray(unitNos) || unitNos.length === 0)
    {
        return [];
    }

    try
    {
        let ls = await wifiList(w);
        let out = [];

        for (let u of unitNos)
        {
            let x = ls.find(a => a.name === u);
            if (x !== undefined)
            {
                out.push({unit: u, password: x.password});
            }
        }

        return out;
    }
    catch (err)
    {
        errorN(`WIFI ERROR: ${err.message}`);
        return [];
    }
}

// Windows wording: "Please login to '<SSID>':-" then "Login: <unit>\t Password: <password>" per unit.
export function wifiHeading(devicesetting) {
    let w = wifiSetting(devicesetting);
    let ssid = w !== null && w.guestSSID !== undefined && w.guestSSID !== null && w.guestSSID !== '' ? w.guestSSID : 'Wifi';
    return `Please login to '${ssid}':-`;
}

// pdfmake content for the A4 printouts; [] when WiFi is off, fails or has no accounts.
export async function wifiPrintBlock(unitNos, devicesetting) {
    let logins = await wifiLogins(unitNos, devicesetting);
    if (logins.length === 0)
    {
        return [];
    }

    return [
        {fontSize: 9, bold: true, font: 'Helvetica', text: wifiHeading(devicesetting), margin: [0, 10, 0, 2]},
        ...logins.map(l => ({fontSize: 9, font: 'Courier', text: `Login: ${l.unit}\t Password: ${l.password}`}))
    ];
}
